import { Field } from 'redux-form';
import { useFela } from 'react-fela';

import EditorInput from '../EditorInput';

import rule from './EditorField.rule';

const EditorField = props => {
    const { css } = useFela();

    return (
        <div className={css(rule)}>
            <Field {...props} component={EditorInput} />
        </div>
    );
};

export default EditorField;
